import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';

import { PSPMarkdownContent } from 'components/psp/PSPMarkdown/';
import './SizeGuideHero.scss';

export default function SizeGuideHero({ title, handleSearch }) {
	return (
		<div className="size-guide-hero">
			<div className="size-guide-hero-content">
				<PSPMarkdownContent content={title} />
				<div className="size-guide-hero-right">
					<Paragraph
						color="white"
						weight="standard"
					>
						Ready to start your storage search? Enter your location
						below:
					</Paragraph>
					<SearchBox
						id="size-guide-hero-sticky-search"
						inputLabel="Enter city or ZIP code"
						handleSearch={handleSearch}
						hideOnScroll
						buttonText="Find Storage"
					/>
				</div>
			</div>
		</div>
	);
}

SizeGuideHero.propTypes = {
	title: PropTypes.string.isRequired,
	handleSearch: PropTypes.func,
};
